export const APP_NAME = '中小学图形化编辑器';
